import distance from "@turf/distance"
import { point as turfPoint } from "@turf/helpers"

export function referralEntity_GetFullAddress(referralEntity) {
  return (
    (referralEntity.address ? referralEntity.address : "") +
    (referralEntity.city ? ", " + referralEntity.city : "") +
    (referralEntity.state ? ", " + referralEntity.state : "") +
    (referralEntity.zip ? ", " + referralEntity.zip : "")
  )
}

export function getDistance(fromLong, fromLat, toLong, toLat, units, rounding) {
  const options = { units: units ? units : "miles" }

  let x = distance(
    turfPoint([fromLong, fromLat]),
    turfPoint([toLong, toLat]),
    options
  )

  x = Math.round(x * 100) / 100

  return x
}

export function mapBox_Places_GetCoordinates(searchlocation, apiKey) {
  const mapBoxKey = apiKey

  if (mapBoxKey !== undefined) {
    let apiURL =
      "https://api.mapbox.com/geocoding/v5/mapbox.places/{SEARCH}.json?access_token={ACCESS_TOKEN}&limit={RESULT_LIMIT}"

    apiURL = apiURL.replace("{ACCESS_TOKEN}", mapBoxKey)
    apiURL = apiURL.replace("{SEARCH}", searchlocation)
    apiURL = apiURL.replace("{RESULT_LIMIT}", "1")

    const Result = fetch(apiURL)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          console.error(response.statusText)
          throw response
        }
      })
      .then((json) => {
        if (!json || !json.features || !json.features.length) {
          console.error("MapBox_Places_GetCoordinates: Invalid response:")
          console.error(json)
          return undefined
        } else {
          const coordinates = {
            longitude: +json.features[0].geometry.coordinates[0],
            latitude: +json.features[0].geometry.coordinates[1],
          }
          return coordinates
        }
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })

    return Result
  } else {
    console.error("MapBox api key not found")
    return undefined
  }
}

export function mapBoxSetFocusedLocation({ focusLocation, map, markers }) {
  const markerData = []
  markerData.push({
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: [focusLocation.longitude, focusLocation.latitude],
    },
    properties: {
      name: "center",
      id: 0,
    },
  })

  const marker = {
    type: "FeatureCollection",
    features: markerData,
  }

  const layer = map.getLayer("center")
  if (layer) {
    let src = map.getSource("center")
    src.setData(marker)
  } else {
    map.loadImage("/mapbox/mapbox-marker-icon-20px-red.png", (error, image) => {
      if (error) throw error
      if (!map.hasImage("RedMarker")) {
        map.addImage("RedMarker", image)
      }
    })

    map.addLayer({
      id: "center",
      type: "symbol",
      /* Add a GeoJSON source containing place coordinates and information. */
      source: {
        type: "geojson",
        data: marker,
      },
      layout: { "icon-image": "RedMarker", "icon-allow-overlap": true },
    })
  }

  if (markers) {
    mapBoxSetMarkers({ map: map, markers: markers, focusLocation })
  }
}

export function mapBoxSetMarkers({ markers, focusLong, focusLat, map }) {
  const layer = map.getLayer("locations")
  if (layer) {
    let src = map.getSource("locations")
    src.setData(markers)
  } else {
    map.loadImage(
      "/mapbox/mapbox-marker-icon-20px-blue.png",
      (error, image) => {
        if (error) throw error
        if (!map.hasImage("BlueMarker")) {
          map.addImage("BlueMarker", image)
        }
      }
    )

    map
      .addLayer({
        id: "locations",
        type: "symbol",
        /* Add a GeoJSON source containing place coordinates and information. */
        source: {
          type: "geojson",
          data: markers,
        },
        layout: { "icon-image": "BlueMarker", "icon-allow-overlap": true },
      })
      .on("mouseenter", "locations", () => {
        map.getCanvas().style.cursor = "pointer"
      })
      .on("mouseleave", "locations", () => {
        map.getCanvas().style.cursor = ""
      })
  }
}

export function getPartnerLocationFeaturePoints(partnerLocations, maxDistance) {
  let features = []
  partnerLocations
    .filter((x) => {
      return x.distance > -1
    })
    .map((x) => {
      const fullAddress = referralEntity_GetFullAddress(x)

      features.push({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [x.longitude, x.latitude],
        },
        properties: {
          name: x.entityName,
          phoneFormatted: x.phone,
          "e-mail": x.email,
          address: fullAddress,
          id: x.locationId,
          locationId: x.locationId,
          distance: x.distance,
          maxDistance: maxDistance,
        },
      })

      return x
    })

  const pointEntriesNew = {
    type: "FeatureCollection",
    features: features,
  }

  return pointEntriesNew
}

export function getBoundingBox(closestMappedEntity, centerPoint) {
  const Latitudes = [closestMappedEntity.latitude, centerPoint.latitude]
  const Longitudes = [closestMappedEntity.longitude, centerPoint.longitude]
  const sortedLongitudes = Longitudes.sort((a, b) => {
    if (a > b) {
      return 1
    }
    if (a < b) {
      return -1
    }
    return 0
  })

  const sortedLatitudes = Latitudes.sort((a, b) => {
    if (a > b) {
      return 1
    }
    if (a < b) {
      return -1
    }
    return 0
  })

  if (
    sortedLongitudes[0] &&
    sortedLatitudes[0] &&
    sortedLongitudes[1] &&
    sortedLatitudes[1]
  ) {
    return [
      [sortedLongitudes[0], sortedLatitudes[0]],
      [sortedLongitudes[1], sortedLatitudes[1]],
    ]
  } else {
    return undefined
  }
}

export function mapUserRoleToFriendlyName(role_id, role_name) {
  switch (role_id) {
    case 9:
      return "Administrator"
    case 10:
      return "User"
    default:
      return role_name
  }
}

export function getServiceCategoryNode(serviceCategory, pathKeys) {
  let node = {
    key: serviceCategory.referralCategory.id,
    label: serviceCategory.referralCategory.name,
    data: serviceCategory.referralCategory.name,
    path: !!pathKeys ? pathKeys : [],
  }

  if (serviceCategory.serviceCategories?.length > 0) {
    node.children = serviceCategory.serviceCategories.map((cat) =>
      getServiceCategoryNode(
        cat,
        !!pathKeys
          ? [...pathKeys, serviceCategory.referralCategory.id]
          : [serviceCategory.referralCategory.id]
      )
    )
  }

  return node
}

export function findServiceCategoryByKey(key, categories) {
  let category = undefined
  if (
    categories?.some((option) => {
      if (option.key.toString() === key) {
        category = option

        return true
      } else if (!!option.children) {
        let childCat = findServiceCategoryByKey(key, option.children)
        if (!!childCat) {
          category = childCat
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    })
  ) {
    return category
  }
}

export function findServiceCategoryChildren(parentCategory) {
  let children = []

  if (parentCategory.children?.length > 0) {
    children = parentCategory.children

    //Find grandchildren
    parentCategory.children.forEach((child) => {
      const grandChildren = findServiceCategoryChildren(child)
      if (grandChildren.length > 0) {
        children = [...children, ...grandChildren]
      }
    })
  }

  return children
}

export function GetMapZoomRange(zoom) {
  let range = 0
  let minRange = 0
  let maxRange = 0

  if (zoom > 14) {
    range = 1
    minRange = 0
    maxRange = 19
  } else if (zoom <= 14 && zoom > 13) {
    range = 20
    minRange = 20
    maxRange = 29
  } else if (zoom <= 13 && zoom > 12) {
    range = 30
    minRange = 30
    maxRange = 39
  } else if (zoom <= 12 && zoom > 11) {
    range = 40
    minRange = 40
    maxRange = 49
  } else if (zoom <= 11 && zoom > 10) {
    range = 50
    minRange = 50
    maxRange = 59
  } else if (zoom <= 10 && zoom > 9) {
    range = 60
    minRange = 60
    maxRange = 99
  } else if (zoom <= 9 && zoom > 8) {
    range = 100
    minRange = 100
    maxRange = 199
  } else if (zoom <= 8 && zoom > 7) {
    range = 200
    minRange = 200
    maxRange = 399
  } else if (zoom <= 7 && zoom > 6) {
    range = 400
    minRange = 400
    maxRange = 499
  } else if (zoom <= 6 && zoom > 5) {
    range = 500
    minRange = 500
    maxRange = 599
  } else if (zoom <= 5 && zoom > 4) {
    range = 600
    minRange = 600
    maxRange = 999
  } else if (zoom <= 4 && zoom > 3) {
    range = 2000
    minRange = 1000
    maxRange = 2000
  } else {
    range = 4500
    minRange = 2001
    maxRange = 4501
  }

  return { range, minRange, maxRange }
}
